import React from 'react';
import "../../styles/StrongerTogether.css"; 

export default function StrongerTogether() {
  return (
    <section className="about-client-stronger-together-dark-section">
      <div className="about-client-max-width stronger-together-capsule">
        
        
        <div className="capsule-airplane-decor-vector">
          <svg viewBox="0 0 100 100" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M20,80 Q40,90 50,70 T70,40 L85,20 L65,35 Z" stroke="rgba(255,255,255,0.15)" strokeWidth="1.5" strokeDasharray="3,3" />
            <path d="M85,20 L45,45 L55,55 Z" fill="rgba(255,255,255,0.2)" />
            <path d="M85,20 L45,45 L80,38 Z" fill="rgba(255,255,255,0.3)" />
          </svg>
        </div>

        
        <div className="stronger-left-gallery-cluster">
          <div className="mosaic-collage-stage">
            
           
            <div className="collage-photo-frame tilt-left-top">
              <img src="https://images.unsplash.com/photo-1540575467063-178a50c2df87?w=400&q=80" alt="Stage panel" />
            </div>

            
            <div className="collage-photo-frame tilt-left-bottom">
              <img src="https://images.unsplash.com/photo-1515187029135-18ee286d815b?w=400&q=80" alt="Creators workshop" />
            </div>

            
            <div className="collage-photo-frame center-main-stream">
              <img src="https://images.unsplash.com/photo-1522202176988-66273c2fd55f?w=500&q=80" alt="Creators celebrating" />
              
              
              <div className="gallery-video-play-center-orb">
                <span className="play-triangle-vector">▶</span>
              </div>
            </div>

            
            <div className="collage-photo-frame tilt-right-top">
              <img src="https://images.unsplash.com/photo-1523240795612-9a054b0db644?w=400&q=80" alt="Community session" />
            </div>

           
            <div className="collage-photo-frame tilt-right-bottom">
              <img src="https://images.unsplash.com/photo-1517245386807-bb43f82c33c4?w=400&q=80" alt="Group meetup" />
            </div>

          </div>
        </div>


        <div className="stronger-right-editorial-metrics">
          <span className="client-uppercase-overline title-yellow-tint">COMMUNITY & IMPACT</span>
          <h2 className="client-section-title text-white">Stronger <span className="gold-inline-span">Together</span></h2>
          <p className="stronger-sub-description-text">
            We're more than a platform — we're a family of creators who support, inspire and celebrate each other's wins.
          </p>
          
         
          <div className="stronger-numerical-dashboard-row">
            
            <div className="dashboard-metric-node">
              <div className="metric-headline-with-icon">
                <span className="node-icon-tint icon-blue">👥</span>
                <h4>50K+</h4>
              </div>
              <p>Active Community Members</p>
            </div>

            <div className="diff-vertical-divider" />

            <div className="dashboard-metric-node">
              <div className="metric-headline-with-icon">
                <span className="node-icon-tint icon-yellow">🏆</span>
                <h4>200+</h4>
              </div>
              <p>Events & Webinars Conducted</p>
            </div>

            <div className="diff-vertical-divider" />

            <div className="dashboard-metric-node">
              <div className="metric-headline-with-icon">
                <span className="node-icon-tint icon-orange">🎓</span>
                <h4>1000+</h4>
              </div>
              <p>Success Stories Created</p>
            </div>

            <div className="diff-vertical-divider" />

            <div className="dashboard-metric-node">
              <div className="metric-headline-with-icon">
                <span className="node-icon-tint icon-white">∞</span>
                <h4>100%</h4>
              </div>
              <p>Memories & Connections</p>
            </div>

          </div>
        </div>

      </div>
    </section>
  );
}